module.exports = __webpack_public_path__ + "media/Footprints/Oil-a92a552b.svg";